module.exports = __webpack_public_path__ + "img/28t.8d5027f5.jpg";